import styled, { css } from 'styled-components';

export const StyledTextArea = styled.textarea(
  ({ theme, backgroundColor = 'white', disabled, isError }) => css`
    min-height: ${theme.spacing.xm};
    resize: none;
    overflow: hidden;
    outline: none;
    color: ${theme.colors.eerieBlack};
    border: 1px solid
      ${isError ? theme.colors.redCrayola : theme.colors.platinumDark};
    border-radius: ${theme.radius.s};
    padding: ${theme.spacing.sm} ${theme.spacing.m};
    background-color: ${disabled
      ? theme.colors.seasalt
      : theme.colors[backgroundColor]};

    &:focus-within {
      border: 1px solid ${theme.colors.eerieBlack};
      background-color: ${theme.colorsInObjects.gray[200]};
    }
  `
);

export const StyledTextAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledTextLabel = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;
